var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4904_37162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5188 6.73623V6.25338L14.1773 6.5948L13.3352 7.43691L13.2767 7.49549V7.57833V10.9468C13.2767 11.7665 12.6122 12.431 11.7925 12.431H5.05561C4.23591 12.431 3.5714 11.7665 3.5714 10.9468V4.20991C3.5714 3.3902 4.23591 2.7257 5.05561 2.7257H8.42403H8.50688L8.56545 2.66712L9.40756 1.82502L9.74898 1.48359H9.26614H4.21351C3.17289 1.48359 2.3293 2.32718 2.3293 3.3678V11.7889C2.3293 12.8295 3.17289 13.6731 4.21351 13.6731H12.6346C13.6752 13.6731 14.5188 12.8295 14.5188 11.7889V6.73623Z",
    fill: "#4F4F4F",
    stroke: "#4F4F4F",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0011 0H11.7906L13.3064 1.51579L7.58008 7.24211L8.75903 8.42105L14.4853 2.69474L16.0011 4.21053V0Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4904_37162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.00195312)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.4b4bb51058c2e3a677b22af367f51e3f.svg";
export { ForwardRef as ReactComponent };